import { Injectable, signal } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable()
export class TopNavbarService {
   topNavbar = signal(false);

   private readonly sectionReclick$ = new Subject<void>();

   /** Emits when the user re-clicks the already-active top-nav section. */
   readonly onSectionReclick: Observable<void> = this.sectionReclick$.asObservable();

   notifySectionReclick(): void {
      this.sectionReclick$.next();
   }
}
